.head {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
}

.head h1 {
  margin-bottom: 4px;
}

.head p {
  max-width: 640px;
}

.tabs {
  display: inline-flex;
  max-width: 100%;
  overflow-x: auto;
  scrollbar-width: none;
  gap: 4px;
  padding: 4px;
  border: 1px solid var(--pill-line);
  border-radius: 999px;
  background: var(--pill-bg);
}

.tab,
.tabActive {
  padding: 6px 14px;
  border: 0;
  border-radius: 999px;
  background: transparent;
  color: var(--muted);
  font-size: 14px;
  white-space: nowrap;
}

.tabActive {
  background: var(--fill);
  background-image: var(--fill-gradient);
  color: var(--on-fill);
}

.controls {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 16px;
  margin-bottom: 16px;
}

.controls label,
.variantConfig label {
  display: flex;
  flex-direction: column;
  gap: 6px;
  color: var(--muted);
  font-size: 13px;
}

.controls .wide {
  min-width: 240px;
}

.check {
  flex-direction: row !important;
  align-items: center;
  color: var(--text) !important;
  font-size: 14px !important;
}

.check input {
  width: auto;
}

.configs,
.configsSingle {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.configsSingle {
  grid-template-columns: minmax(0, 1fr);
  max-width: 520px;
}

.variantConfig {
  display: grid;
  gap: 10px;
  margin: 0;
  padding: 12px 14px 14px;
  border: 1px solid var(--line);
  border-radius: 12px;
}

.variantConfig legend {
  padding: 0 6px;
  color: var(--accent);
  font-size: 14px;
}

.inputBox {
  margin: 16px 0 12px;
  font-size: 14px;
}

.results,
.resultsSingle {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.resultsSingle {
  grid-template-columns: minmax(0, 1fr);
}

.result {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 16px;
  border: 1px solid var(--line);
  border-radius: 14px;
  background: var(--surface);
}

.resultHead {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
}

.resultHead h3 {
  margin: 0;
}

.resultHead span {
  font-size: 12px;
  overflow-wrap: anywhere;
}

.original summary {
  cursor: pointer;
  color: var(--muted);
  font-size: 13px;
}

.rating {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  font-size: 13px;
}

.rating button {
  min-width: 36px;
  padding: 6px 10px;
}

.coverage {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 8px;
  margin: 12px 0 20px;
}

.cell {
  display: grid;
  gap: 2px;
  padding: 8px 10px;
  border: 1px solid var(--line);
  border-radius: 10px;
  background: transparent;
  color: var(--text);
  text-align: left;
}

.cellNum {
  color: var(--muted);
  font-family: var(--font-display);
  font-size: 12px;
}

.cellName {
  overflow: hidden;
  font-size: 13px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cellCount {
  font-size: 12px;
}

.cellFull .cellCount {
  color: var(--ok);
}

.cellPartial .cellCount {
  color: var(--accent);
}

.cellEmpty .cellCount {
  color: var(--muted-dim);
}

.cellSelected {
  border-color: var(--accent);
  box-shadow: inset 0 0 0 1px var(--accent);
}

.library h2 {
  margin-bottom: 12px;
}

.example {
  display: grid;
  gap: 10px;
  margin-bottom: 12px;
  padding: 14px 16px;
  border: 1px solid var(--line);
  border-radius: 12px;
}

.exampleExcluded {
  opacity: 0.6;
}

.exampleHead {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 8px;
  font-size: 12px;
}

@media (max-width: 760px) {
  .configs,
  .results {
    grid-template-columns: minmax(0, 1fr);
  }

  .controls select {
    min-width: 0;
    width: 100%;
  }

  .controls label {
    flex: 1 1 100%;
  }
}

.chat {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 16px 0;
}

.bubble {
  display: grid;
  gap: 8px;
  max-width: 760px;
  padding: 12px 14px;
  border: 1px solid var(--line);
  border-radius: 14px;
}

.bubbleUser {
  align-self: flex-end;
  background: var(--pill-bg);
}

.bubbleMila {
  align-self: flex-start;
  width: min(760px, 100%);
  background: var(--surface);
}

.bubbleText {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.bubbleMeta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  color: var(--muted);
  font-size: 12px;
}

.chatInput {
  display: grid;
  gap: 10px;
  margin-bottom: 20px;
}

.chatExamples summary {
  cursor: pointer;
  margin-bottom: 12px;
  color: var(--muted);
}

.slotTabs {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin: 12px 0 16px;
}

.promptText,
.diff {
  max-height: 560px;
  margin: 0;
  padding: 14px 16px;
  overflow: auto;
  border: 1px solid var(--line);
  border-radius: 12px;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 13px;
  line-height: 1.55;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.diffAdd {
  background: color-mix(in srgb, var(--ok) 18%, transparent);
}

.diffDel {
  background: color-mix(in srgb, var(--danger) 18%, transparent);
  text-decoration: line-through;
  text-decoration-color: color-mix(in srgb, var(--danger) 60%, transparent);
}
